import React from "react";
import { SmmDomainTable } from "../../UI/SmmDomain/SmmDomainTable";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";

const SmmDomain = () => {
  return (
    <div>
      <PanelHead title="Marketer" />
      <PanelBody content={<SmmDomainTable />} />
    </div>
  );
};

export default SmmDomain;
